import React from 'react'

const steps = [
  {
    number: '01',
    title: 'Discovery & Product Strategy',
    text: 'We map business goals, users, integrations, and monetization before mobile app development begins, so every release has a clear product reason.'
  },
  {
    number: '02',
    title: 'UX, Wireframes & Scope',
    text: 'Our product team turns ideas into journeys, screens, and acceptance criteria for custom mobile app development that feels simple to use and realistic to build.'
  },
  {
    number: '03',
    title: 'UI Design & Prototype',
    text: 'Interactive prototypes help founders review the experience early, align stakeholders, and prepare a confident path for ios app development and android app development.'
  },
  {
    number: '04',
    title: 'Agile Engineering',
    text: 'Dedicated mobile app developers in pakistan build secure features in sprints with clean code, version control, API discipline, and transparent progress reviews.'
  },
  {
    number: '05',
    title: 'QA, Launch & Store Readiness',
    text: 'We test performance, accessibility, device behavior, backend reliability, and release requirements before the app reaches customers.'
  },
  {
    number: '06',
    title: 'Growth, Support & Iteration',
    text: 'After launch, our mobile app development in pakistan team tracks usage, fixes friction, and improves features so the product keeps earning user trust.'
  },
]

const OurProcessSection = ({ items = steps, eyebrow = 'OUR PROCESS', heading = 'Our Process for Building Mobile Apps', intro = 'A practical delivery model for mobile app development, from idea validation to post-launch improvement.' }) => {
  return (
    <section className="app-process-section py-5">
      <div className="container position-relative">
        <span className="app-process-watermark" aria-hidden="true">Process</span>
        <div className="mb-4 app-process-heading">
          <h2 className="pb-3 h5 app-section-eyebrow">{eyebrow}</h2>
          <h3 className="display-6 fw-bold text-white">{heading}</h3>
          <p className="lead text-white-50">
            {intro}
          </p>
        </div>
        <div className="row">
          {items.map((step) => (
            <div className="col-12 col-lg-4 my-2" key={step.number}>
              <article className="app-process-card h-100">
                <span className="app-process-number">{step.number}</span>
                <h4>{step.title}</h4>
                <p>{step.text}</p>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default OurProcessSection
